import { helper } from '@ember/component/helper';

import { qpDateRangeIsUnfilled } from 'rise-ui/utils/qp-date.js';


export default helper(function qpDateUnfilledHelper([ dates ], options) {
  return qpDateRangeIsUnfilled(dates, options);
});
